import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { TimesheetDaily, TimesheetDailySearchDTO } from '../employees/model/timesheet-daily.model';
import { logRequest } from '../shared/http-utils';

@Injectable({
    providedIn: 'root',
})
export class IrregularWorkPlanService implements OnDestroy {
    baseUrl = '/school-service/api/irregular-work-plan';

    constructor(private http: HttpClient) {
        console.log('Timesheet Daily service created!');
    }

    getBySearch(dto: TimesheetDailySearchDTO): Observable<HttpResponse<TimesheetDaily[]>> {
        return this.http.post<TimesheetDaily[]>(`${this.baseUrl}/search`, dto, { observe: 'response' });
    }

    saveAll(dailyTimesheets: TimesheetDaily[]): Observable<HttpResponse<TimesheetDaily[]>> {
        return this.http.post<TimesheetDaily[]>(`${this.baseUrl}/save`, dailyTimesheets, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    delete(listOfIDs: string[]): Observable<HttpResponse<any>> {
        return this.http.post<any>(`${this.baseUrl}/delete`, listOfIDs, { observe: 'response', headers: logRequest() });
    }

    ngOnDestroy() {
        console.log('School dto service destroyed!');
    }
}
